<template>
  <div class="park-levelist">
    <Row>
      <Col :xs="24" :sm="24">
        <Form :model="formItem" ref="formItem" :inline="true" action="javascript:void(0)">
          <FormItem>
            <Button @click="showModel()" type="success" class="f-r">添加等级</Button>
          </FormItem>
        </Form>
      </Col>
    </Row>
    <Table border :columns="columns1" ref="selection" :data="tablelist" :loading="dataloading"></Table>
    <!-- 添加的弹出 -->
    <Modal
      v-model="showModalStatus"
      title="添加等级"
      @on-ok="createlevel('levelValidate')"
      :loading="loading"
    >
      <Form :model="level" ref="levelValidate" :rules="levelValidate" action="javascript:void(0)">
        <FormItem label="等级名称" prop="name">
          <Input v-model="level.name" placeholder="输入等级名称..."></Input>
        </FormItem>
        <FormItem label="累计消费金额">
          <Input v-model="level.pay_money" placeholder="输入金额..."></Input>
        </FormItem>
        <FormItem label="折扣">
          <Input v-model="level.discount" placeholder="输入折扣..." style="width:200px"></Input>%
        </FormItem>
      </Form>
    </Modal>
    <!-- 修改的弹出 -->
    <Modal
      v-model="showEditInfoStatus"
      title="修改等级"
      @on-ok="updatelevel('levelValidate')"
      :loading="loading"
    >
      <Form :model="level" ref="levelValidate" :rules="levelValidate" action="javascript:void(0)">
        <FormItem label="等级名称" prop="name">
          <Input v-model="level.name" placeholder="输入等级名称..."></Input>
        </FormItem>
        <FormItem label="累计消费金额">
          <Input v-model="level.pay_money" placeholder="输入金额..."></Input>
        </FormItem>
        <FormItem label="折扣">
          <Input v-model="level.discount" placeholder="输入折扣..." style="width:200px"></Input>%
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "park-levelist",
  data() {
    return {
      loading: true,
      dataloading: true,
      formItem: {},
      columns1: [
        {
          title: "ID",
          key: "id",
          width: 100,
          fixed: "left"
        },
        {
          title: "名称",
          key: "name",
          width: 100,
          fixed: "left"
        },
        {
          title: "累计消费",
          key: "pay_money",
          fixed: "left"
        },
        {
          title: "折扣",
          key: "discount",
          fixed: "left"
        },
        {
          title: "操作",
          key: "action",
          align: "left",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "info",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.showEditInfo(params.row.id);
                    }
                  }
                },
                "修改"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.remove(params.row.id);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ],
      tablelist: [],
      level: {},
      showModalStatus: false,
      showEditInfoStatus: false,
      levelValidate: {
        name: [{ required: true, message: "名称必须填写", trigger: "blur" }]
      }
    };
  },
  // 计算
  computed: {},
  // 监听
  watch: {},
  created: function() {
    this.park_uuid = this.$route.params.park_uuid;
    // 取数据
    this.getTableList();
  },
  methods: {
    getTableList: function() {
      var self = this;
      this.$api.park.levellist({ park_uuid: this.park_uuid }).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          self.tablelist = res.result;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    // 展开添加
    showModel() {
      this.level = {};
      this.$refs["levelValidate"].resetFields();
      this.showModalStatus = !this.showModalStatus;
    },
    // 添加
    createlevel(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.$api.park
            .levelcreate({
              park_uuid: this.park_uuid,
              name: this.level.name,
              pay_money: this.level.pay_money,
              discount: this.level.discount
            })
            .then(res => {
              if (res.code == 200) {
                this.showModalStatus = !this.showModalStatus;
                this.level.name = "";
                this.getTableList();
              }
            });
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
        } else {
          this.$Message.error("请检查输入的信息是否正确！");
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
        }
      });
    },
    //展开修改
    showEditInfo: function(index) {
      this.levelid = index;
      this.$refs["levelValidate"].resetFields();
      this.showEditInfoStatus = !this.showEditInfoStatus;
      // 取信息
      this.$api.park.leveldetail({ id: index }).then(res => {
        if (res.code == 200) {
          this.level = res.result;
          this.$Message.success(res.msg);
        }
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true;
        });
      });
    },
    // 修改名称
    updatelevel: function(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          console.log(this.level);
          this.$api.park
            .leveledit({
              id: this.levelid,
              name: this.level.name,
              pay_money: this.level.pay_money,
              discount: this.level.discount
            })
            .then(res => {
              if (res.code == 200) {
                this.$Message.success(res.msg);
                this.showEditInfoStatus = !this.showEditInfoStatus;
                this.getTableList();
              }
              this.loading = false;
              this.$nextTick(() => {
                this.loading = true;
              });
              this.showCreateStatus = !this.showCreateStatus;
            });
        } else {
          this.$Message.error("请检查输入的信息是否正确！");
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
        }
      });
    },
    remove: function(index) {
      // 弹出确认框
      this.$Modal.confirm({
        title: "警告",
        content: "<p>此操作不可恢复，三思而后行...</p>",
        onOk: () => {
          this.$api.park.levelremove({ id: index }).then(res => {
            if (res.code == 200) {
              this.$Message.success(res.msg);
              // this.tablelist.splice(index, 1);
              this.getTableList();
            }
          });
        }
      });
    }
  }
};
</script>
